import { computed, ref, toValue } from "vue";
import { toBoolean } from "#ce/utils/props";

export function useImgFallback(noPlaceholder) {
  const imageError = ref(false);

  const showPlaceholder = computed(() => imageError.value && !toBoolean(toValue(noPlaceholder)));

  function handleImageError() {
    imageError.value = true;
  }

  function handleImageLoad() {
    imageError.value = false;
  }

  return { handleImageError, handleImageLoad, showPlaceholder };
}
